__webpack_require__.p = "https://centroanaliticodepatologia.com.mx/";